import $http from '../../../utils/ajax';

/**
 * 增加学习数量
 * @param {Number} courseId 课程 id
 */

let isSubmit;
export const addStudyCnt = courseId => {
    isSubmit = true;
    $http.post('/bp/course/incrstudycnt', {
        // 课程 id
        item_id: courseId
    }).finally(() => {
        isSubmit = false;
    });
};

export const defaultPic = 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/course-center/pic-loading.png';